import MUIFormControl from '@mui/material/FormControl';

type FormControlProps = {
  variant?: 'standard' | 'outlined' | 'filled';
  sx?: any;
  fullWidth?: boolean;
  children?: React.ReactNode;
  props?: any;
  required?: boolean;
};

// TODO: Remove once the MUI transition includes FormControl
export default function FormControl({
  variant,
  sx,
  fullWidth = true,
  children,
  required = false,
  ...props
}: Readonly<FormControlProps>) {
  return (
    <MUIFormControl
      required={required}
      variant={variant}
      sx={sx}
      fullWidth={fullWidth}
      {...props}
    >
      {children}
    </MUIFormControl>
  );
}
